import { LadiesMain } from "../../global/ladies-main"
import { Galerie } from "./Galerie.js"
import StarsVideos from "./StarsVideos.js"

export default class GalerieStars extends Galerie {
    /**
     * @property {NodeList|Array} players
     */

    constructor(galleryConfig) {
        super(galleryConfig)

        this.players = []
        this.galleryVideos = new StarsVideos()
    }

    initConfig(galleryConfig) {
        galleryConfig.domPlayerId = "lds-video-player"
        galleryConfig.noBannerOnGalleryClosed = true

        super.initConfig(galleryConfig)

        this.showThumbs = false

        // Disable scrolling to the next slide
        $(document).on("touchstart pointerdown mousedown", this.config.domSliderlId, (/** Event */ event) => {
            event.preventDefault()
        })
    }

    getConfig() {
        return {
            fullscreen: {
                enabled: true,
                nativeFS: false,
                buttonFS: false,
            },
            controlNavigation: "thumbnails",
            autoScaleSlider: false,

            imageAlignCenter: false,

            loop: true,
            imageScaleMode: this.config.showMobileView === true ? "none" : "fit-if-smaller",
            navigateByClick: false,
            numImagesToPreload: 2,
            arrowsNav: false,
            arrowsNavAutoHide: false,
            arrowsNavHideOnTouch: false,
            keyboardNavEnabled: false,
            fadeinLoadedSlide: true,
            globalCaption: false,
            globalCaptionInside: false,
            imageScalePadding: 0,
        }
    }

    postSliderContainer() {
        /** HTMLElement */
        return this.sliderContainer.get(0)
    }

    registerThumbsConfig(config) {
        config.controlNavigation = "none"

        return config
    }

    openSlider() {
        super.openSlider()

        this.generateGalleryVideos(this.config.domSliderlId)

        $(`${this.config.domSliderlId} .rsFullscreenBtn`).appendTo(this.config.domSliderlId)
        $(this.config.domSliderlId).show()
    }

    _eventAfterSlideChange() {
        /** void */
        this.slider?.ev?.on("rsAfterSlideChange", () => {
            $(document).trigger("slideChanged:gallery.royal-slider", this.slider)

            if ("currSlide" in this.slider) {
                const currentSlide = this.slider.currSlide

                this.sendSlideChangeNotification(currentSlide)
                this.trackSlide(currentSlide)
            }

            $(document).trigger("gallery:reopened")
        })
    }

    _eventVideoClicked() {
        // We don't need this for ldsVideoPlayer,
        // but we have to override it to prevent call to original code for FlowPlayer
    }

    _registerVideoPlayers() {
        /** void */
        // Don't register videos here, since they will be generated on-demand when opening
        // a gallery with Video slides, not during initialization
    }

    _pauseAllPlayers() {
        for (const playerElement of this.players) {
            if (!playerElement.player) {
                return
            }

            playerElement.player.pause()
        }
    }

    _suppressEscapeButtonOnVideo() {
        // This appears to happen automatically with ldsVideoPlayer / videojs,
        // but we have to override this method to prevent call to original code for FlowPlayer
    }

    sendSlideChangeNotification(/** RoyalSliderSlide */ currentSlide) {
        /** void */
        LadiesMain.nodesUpdated.notify({
            state: {
                addedNodes: [currentSlide.content.get(0)],
                removedNodes: [],
            },
        })
    }

    trackSlide(/** RoyalSliderSlide */ currentSlide) {
        /** void */
        this.track($(currentSlide.content[0]).hasClass("additional-banner"))
    }

    initializeGalleryVideo(/** Event */ readyEvent) {
        /** void */
        const playerContainer = readyEvent.target
        const videoPlayer = playerContainer.player

        if (videoPlayer.videoWidth() < 1 || videoPlayer.videoHeight() < 1) {
            videoPlayer.on("loadedmetadata", () => {
                this.updatePlayerSize(playerContainer, videoPlayer.videoWidth(), videoPlayer.videoHeight())
            })
        } else {
            this.updatePlayerSize(playerContainer, videoPlayer.videoWidth(), videoPlayer.videoHeight())
        }

        this.addVideoPlayerEvents(videoPlayer, playerContainer)
    }

    updatePlayerSize(/** ldsVideoPlayer */ container, /** number */ width, /** number */ height) {
        /** void */
        const videoSlideContentElement = container.closest(".content")

        videoSlideContentElement.style.maxWidth = `${width}px`
        videoSlideContentElement.style.aspectRatio = width / height
    }

    addVideoPlayerEvents(/** Player */ videoPlayer, /** ldsVideoPlayer */ playerContainer) {
        /** void */
        const playerContentSlideElement = playerContainer.closest(".videoContent")

        playerContentSlideElement.addEventListener("click", (clickEvent) => clickEvent.stopPropagation())

        videoPlayer.one("play", () => {
            const playIcon = playerContentSlideElement.querySelector(".video-play")

            playIcon.parentElement.removeChild(playIcon)
        })

        videoPlayer.on("fullscreenchange", () => {
            this.flowplayerIsFullscreen = videoPlayer.isFullscreen()
        })

        videoPlayer.one("progress", (loadEvent) => {
            if (!playerContainer.classList.contains("rsNoDrag")) {
                playerContainer.classList.add("rsNoDrag")
            }
        })
    }

    generateGalleryVideos(/** string */ sliderId) {
        /** void */
        this.galleryVideos.updateLDSVideoPlayerData(sliderId)

        this.players = this.postSliderContainer().querySelectorAll(this.config.domPlayerId)
        for (const playerWrapper of this.players) {
            playerWrapper.addEventListener("click", (clickEvent) => clickEvent.stopPropagation(), {
                once: true,
            })
            playerWrapper.addEventListener("ready", (readyEvent) => this.initializeGalleryVideo(readyEvent), {
                passive: true,
            })
        }
    }
}
